import { StyleSheet } from '@react-pdf/renderer';
import { theme } from '../../styles/styles';

export const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: theme.white,
    margin: 0,
    fontFamily: 'Albert Sans',
  },
  header: {
    backgroundColor: theme.secondaryColor,
    height: 80,
    color: theme.white,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  innerHeader: {
    marginLeft: 35,
    color: theme.white,
    fontSize: 24,
    fontWeight: 800,
    textAlign: 'left',
  },
  logo: {
    width: 100,
    marginLeft: 20,
  },
  mainPage: {
    width: '100%',
    padding: '14 50 14 50',
  },
  titleText: {
    fontSize: 20,
    marginBottom: 6,
    fontWeight: 700,
    color: theme.secondaryColor,
  },
  subheader: {
    fontSize: 14,
    color: theme.secondaryColor,
    marginTop: 4,
    marginBottom: 4,
    fontWeight: 'bold',
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: theme.secondaryColor,
    marginTop: 6,
    marginBottom: 4,
    padding: '4 0',
  },
  gridItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '10 14',
  },
  gridRow: {
    flexDirection: 'row',
  },
  gridCell: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '4 14',
  },
  gridCellDivider: {
    width: 0.25,
    backgroundColor: theme.grayLight,
  },
  gridTitle: {
    fontSize: 9,
    fontWeight: 600,
    color: theme.secondaryColor,
  },
  gridValue: {
    fontSize: 9,
    fontWeight: 600,
    color: theme.primaryColor,
    textAlign: 'right',
  },
  incentiveContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: theme.bgColor,
    borderRadius: 6,
    width: '100%',
    padding: '12 14',
    marginBottom: 12,
    marginTop: 8,
  },
  incentiveTitle: {
    fontSize: 11,
    color: theme.secondaryColor,
    fontWeight: 'bold',
    paddingBottom: 4,
  },
  incentiveBody: {
    fontSize: 10,
    color: theme.secondaryColor,
    paddingLeft: 8,
  },
  incentiveBodyLine: {
    fontSize: 10,
    color: theme.secondaryColor,
    paddingBottom: 3,
  },
  // Program benefits
  benefitSection: {
    marginTop: 6,
    marginBottom: 4,
    padding: '8 14',
    backgroundColor: theme.secondaryColorLight,
    borderRadius: 4,
  },
  benefitRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  stoplightDot: {
    width: 15,
    height: 11,
    borderRadius: 3,
    marginRight: 8,
  },
  benefitTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: theme.secondaryColor,
  },
  benefitText: {
    fontSize: 10,
    fontWeight: 500,
    color: theme.secondaryColor,
    lineHeight: 1.5,
  },
  benefitTextBold: {
    fontSize: 10,
    fontWeight: 700,
    color: theme.secondaryColor,
  },
  // Revenue & Costs
  costColumns: {
    flexDirection: 'row',
    gap: 20,
    marginTop: 6,
  },
  costColumn: {
    flex: 1,
    flexDirection: 'column',
    padding: '12 14',
    backgroundColor: theme.secondaryColorLight,
    borderRadius: 4,
  },
  monthlyCostColumns: {
    flexDirection: 'row',
    width: '50%',
    marginTop: 6,
  },
  costColumnTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    color: theme.secondaryColor,
    marginBottom: 6,
  },
  costDivider: {
    borderTopWidth: 0.5,
    borderTopColor: theme.secondaryColor,
    marginVertical: 6,
  },
  costRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  costLabel: {
    fontSize: 10,
    fontWeight: 500,
    color: theme.secondaryColor,
    flex: 1,
    paddingRight: 6,
  },
  costAmount: {
    fontSize: 10,
    fontWeight: 'bold',
    color: theme.secondaryColor,
    textAlign: 'right',
  },
  costRevenue: {
    fontSize: 10,
    fontWeight: 'bold',
    color: theme.primaryColor,
    textAlign: 'right',
  },
  costTotal: {
    fontSize: 11,
    fontWeight: 'bold',
    color: theme.secondaryColorDark,
  },
  caasInfoBox: {
    marginTop: 20,
    padding: '8 10',
    backgroundColor: theme.secondaryColorLight,
    borderLeftWidth: 3,
    borderLeftColor: theme.secondaryColor,
    borderRadius: 4,
  },
  caasInfoBoxTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: theme.secondaryColor,
    marginBottom: 4,
  },
  caasInfoBoxText: {
    fontSize: 9,
    color: theme.secondaryColorDark,
    lineHeight: 1.5,
  },
});
